export default __webpack_public_path__ + "static/media/arrow_up.88db9b3c.svg";